// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"12e755d0","455":"0e1e7dd1","488":"b5a22bde","977":"3550c40b"}[chunkId] + ".chunk.js";
};